import type { RouteRecordRaw } from 'vue-router'
import organizations from '@helm/routes/organizations'
import users from '@helm/routes/users'
import config from '@helm/routes/config'
import messaging from '@helm/routes/messaging'

const helmRoutes: readonly RouteRecordRaw[] = [
    {
        path: `/`,
        component: () => import('@helm/pages/Home.vue'),
        name: `home`
    },
    {
        path: `/login`,
        component: () => import('@helm/pages/Login.vue'),
        meta: {
            layout: `auth`
        },
        name: `login`
    },
    {
        path: `/logout`,
        component: () => import('@helm/pages/Logout.vue'),
        meta: {
            layout: `auth`
        },
        name: `logout`
    },
    ...organizations,
    ...users,
    ...config,
    ...messaging
]

export default helmRoutes
